import React, {ReactElement, useEffect, useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {acceptInvitationService} from '@shared/services/PublicService';
import {
  Card,
  CardContent,
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Button
} from '@material-ui/core';
import {useSnackbar} from 'notistack';
import Loader from '@components/framework/loader/Loader';
import './AcceptInvitation.scss';
import NavRoutes from '../../../constants/route/NavRoutes';
import {SnackBarConfig} from '../../../utils/SnackBarConfig';
import {
  FONT_SECONDARY_COLOR,
  BORDER_PRIMARY_COLOR,
  APP
} from 'src/style/variable';
import MedopsLogo from '@components/system/MyIcons/MedopsLogo';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    FormLabel: {
      left: '-0.8rem',
      fontSize: '1.2rem',
      color: FONT_SECONDARY_COLOR
    },
    appBar: {
      color: theme.palette.text.primary,
      background: theme.palette.background.paper,
      boxShadow: 'none',
      [theme.breakpoints.up('md')]: {
        width: `100%`
      }
    },
    AcceptInvitationButton: {
      justifyContent: 'center',
      display: 'flex',
      textAlign: 'center',
      alignItems: 'center',
      paddingBottom: '1.2rem'
    },
    formWrapper: {
      // borderRadius: 0,
      marginTop: '1rem !important',
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: BORDER_PRIMARY_COLOR,
        top: 0,
        '& legend': {
          display: 'none'
        }
      }
    },
    button: {
      fontFamily: APP.FONT_FAMILY.BOLD,
      height: '2.7rem',
      justifyContent: 'center',
      padding: 0,
      '& .span': {
        padding: 0
      }
    },
    AcceptInvitationTitle: {
      display: 'flex',
      left: 0,
      paddingBottom: '2.5rem',
      fontFamily: APP.FONT_FAMILY.MEDIUM,
      fontSize: '1.7rem'
    },
    copyRightText: {
      fontSize: '1rem'
    }
  })
);

const AcceptInvitation = ({history, match}: any): ReactElement => {
  const classes = useStyles();
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const [loader, setLoader] = useState<boolean>(true);
  const {token} = match.params;
  const [practiceGroup, setPracticeGroup] = useState<string>('Practice Group');

  const redirectToLogin = () => {
    history.push(`/${NavRoutes.PUBLIC.LOGIN}`);
  };

  const renderLogo = (): ReactElement => {
    return (
      <div className="vaxin-track-logo">
        <MedopsLogo style={{height: '10%', width: '40%'}} />
      </div>
    );
  };

  useEffect(() => {
    acceptInvitationService({
      token
    })
      .then(res => {
        if (res?.data?.practice_group_name) {
          setPracticeGroup(res.data.practice_group_name);
        }
        enqueueSnackbar(t('INVITATION.SUCCESS'), SnackBarConfig('s'));
      })
      .catch(err => {
        enqueueSnackbar(err.message || t('APP.ERROR'), SnackBarConfig('e'));
        redirectToLogin();
      })
      .finally(() => {
        setLoader(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enqueueSnackbar, t, token]);
  return (
    <div className="acceptInvitation-wrapper flex-centering">
      <div className="acceptInvitation-content-wrap">
        {renderLogo()}
        <Card className="card-wrapper">
          <CardContent className="card-content">
            <div className="acceptInvitation-form">
              <Typography
                className={classes.AcceptInvitationTitle}
                variant={'h3'}>
                {t('INVITATION.TITLE')}
              </Typography>
              {loader ? (
                <Loader />
              ) : (
                <div>
                  <Typography className="note">
                    <Trans
                      i18nKey={'INVITATION.NOTE'}
                      values={{
                        practice_group: practiceGroup
                      }}
                      components={[<strong key={'X'} />]}
                    />
                  </Typography>
                  <div className={classes.AcceptInvitationButton}>
                    <Button
                      variant="contained"
                      size={'medium'}
                      color="primary"
                      className={['block', classes.button].join(' ')}
                      onClick={redirectToLogin}>
                      {t('INVITATION.SIGN_IN')}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AcceptInvitation;
